import React from 'react';
import {connect} from 'react-redux';
import * as R from 'ramda';
import {ClipboardOutlineIcon, EyeOffOutlineIcon} from 'mdi-react';
import {TableContainer, Table, Tr, Td, TBody} from '@cjdev/visual-stack/lib/components/Table';
import { Button } from '@cjdev/visual-stack/lib/components/Button';
import {Panel, Header, Body} from '@cjdev/visual-stack/lib/components/Panel';
import { abilitiesOf } from '../../abilities';


const Credentials = ({credentials}) => {

    if (credentials.type === "AWS") {
        return(
            <div>
                <div><a target="cjops_awsconsole" href={credentials.value.consoleUrl}>Web Console</a></div>
                <div style={{"marginTop":"1em"}}>
                    <div style={{"display":"inline-block", "marginRight":"1em", "verticalAlign":"top"}}>
                        Command Line: <br />
                        <a onClick={() => {}}><ClipboardOutlineIcon /></a>
                        <a onClick={() => {}}><EyeOffOutlineIcon /></a>
                    </div>
                    <div style={{"display":"inline-block"}}>
                        <div style = {{"fontFamily":"monospace"}}>
                            AWS_ACCESS_KEY_ID='{credentials.value["AWS_ACCESS_KEY_ID"]}'<br/>
                            AWS_SECRET_ACCESS_KEY='{credentials.value["AWS_SECRET_ACCESS_KEY"]}'<br/>
                            AWS_SESSION_TOKEN='{credentials.value["AWS_SESSION_TOKEN"]}'<br/>
                        </div>
                    </div>
                </div>
            </div>
        );
    } else  {
        return <div>dunno :( </div>
    }


};

const Ability = ({ability}) => {
    if (ability.credentials) {
        return <Tr>
            <Td>{ability.account}</Td>
            <Td>
                {ability.credentials.renewable ? <span><Button type="primary">Renew (countdown?)</Button><br/></span> : null}
                <Button type="primary">Revoke</Button>
            </Td>
            <Td>
                <Credentials credentials = {ability.credentials} />
            </Td>
        </Tr>
    } else {
       return <Tr>
            <Td>{ability.account}</Td>
            <Td><Button type="primary">Request</Button></Td>
            <Td />
        </Tr>
    }
};

const Role = ({role, abilities}) => {
    return (
        <Panel>
            <Header>{role}</Header>
            <Body>
                <TableContainer>
                    <Table>
                        <TBody>
                            {abilities.map(a => <Ability key = {`${a.role}${a.account}${a.dual}`} ability = {a} />)}
                        </TBody>
                    </Table>
                </TableContainer>
            </Body>
        </Panel>
    );

};

const Abilities = ({ abilities }) => {

    const roles = R.uniq(R.map(({role}) => role, abilities));

    return (
        <React.Fragment>
           {roles.map(r => <Role key={r} role={r} abilities = {R.filter(a => a.role === r, abilities)} />)}
        </React.Fragment>
    );
};

const ConnectedAbilities = connect(
    state => ({
        abilities: abilitiesOf(state)
    })
)(Abilities);

export { Abilities, ConnectedAbilities };




// WEBPACK FOOTER //
// ./src/view/AccessPage/Abilities.js